import SplashPage from './SplashPage'

export default SplashPage
